import { Group, Text, ThemeIcon, Title } from 'components'
import { HUB_ICON_SIZE, HUB_THEME_ICON_SIZE } from '../constants'
import { getHubStyle } from '../hubStyles'
import type { SanityHubWithArticles } from '../interfaces'

interface HubHeaderProps {
  hub: SanityHubWithArticles
}

// Section header shown above a hub's article list: icon, name, description.
export const HubHeader = ({ hub }: HubHeaderProps) => {
  const { icon: Icon, color } = getHubStyle(hub.slug, hub.color, hub.icon)

  return (
    <Group spacing='md' noWrap align='flex-start'>
      <ThemeIcon size={HUB_THEME_ICON_SIZE} radius='md' color={color} variant='light'>
        <Icon size={HUB_ICON_SIZE} />
      </ThemeIcon>
      <div>
        <Title order={2} mb={4}>
          {hub.title}
        </Title>
        {hub.description ? (
          <Text color='dimmed' size='sm'>
            {hub.description}
          </Text>
        ) : null}
      </div>
    </Group>
  )
}
